/**
 * PageLoader – full-area loading state for V2 pages. Show while initial data is being fetched.
 */
import React from "react";
import { Wrapper, Spinner, Message } from "./PageLoader.style";

export default function PageLoader({ message = "Loading..." }) {
  return (
    <Wrapper aria-busy="true" aria-live="polite" role="status">
      <Spinner aria-hidden />
      <Message>{message}</Message>
    </Wrapper>
  );
}
